import { JamCanvasAnimate } from "./types.js";
export const PROGRESSIVE = true;
export const TILE_SIZE = 512;
export const TILE_INCREMENT = 1;
export const LABEL_MIN_SIZE = 12;
export const LABEL_MAX_SIZE = 24;
export const LABEL_MARGIN = 12;
export const SCALE = 1;
export const MIN_TILES = 1;
export const DELAY = 0;
export const ANIMATE: JamCanvasAnimate = true;
export const ANIMATION_DURATION = 200;
export const BACKGROUND_COLOR = "rgba(255,255,255,0)";
export const ANIMATION_STEPS = 5;
export const MAX_ZOOM = 10;
export const MIN_ZOOM = 0.75;
export const SHOW_LOADING = true;
export const THROTTLING = 50;
